<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HReyLe/tc-custom/cover.jpeg?1685327423722?1692044794137" alt="This image is the cover for the book Lovesick Gods, Lovesick"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lovesick Gods, Lovesick
      </h1>
      <p class="bookDescription body article font2">
        <p>Heroes aren't meant to act like their villains -- or fall in love with them.<br/><br/>The elements touch everyone on Earth -- Fire, Water, even Light -- but every so often someone becomes more attuned to their elemental leaning and develops true power. When an evil Elemental known as Thanatos arrived in Olympus City, it saw the rise of its first hero -- Zeus.<br/><br/>But the death toll caused by defeating Thanatos changed Zeus, who by day is young detective Danny Grant. It's been six months since Thanatos terrorized the city at the start of Lovesick Gods. Danny should be used to his duty behind the mask, but the recent past haunts him. His girlfriend left him, he snaps at the barest provocation, his life feels empty -- he needs an outlet, any outlet to pull him out of his depression. <br/><br/>Enter notorious thief Malcolm Cho, the Ice Elemental Prometheus. There was a time when Danny welcomed a fight with Cho, filled with colorful banter and casual flirtations that were a relief compared to Thanatos. Even as a criminal, Cho had recognized the threat Thanatos posed and promised to help Danny stop him, but the day Danny needed Cho, he never showed. Cho was the reason so many people died that day -- including Danny's mother.<br/><br/>Danny decides to teach the man a lesson and fan the fire of their attraction into something more. At worst, he'll get some no-strings-attached sex out of the deal and finally blow off steam; at best, he'll get Cho to fall in love with him and then break his heart to spite him. Danny doesn't expect to fall for Cho in the process, and he certainly can't predict the much darker threat on the horizon.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Meuwissen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Big World Network 2011
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?562c2892